module.exports = __webpack_public_path__ + "media/images/application/template/logos/cards-logo-61eee77f43cfe2226eac58f56671bc13.png";